import './DraftView.less';
import React from 'react';
import DraftHelper from "../../helpers/DraftHelper";


export default function DraftView({contentState}) {

    return <div
        className="draft-view"
        dangerouslySetInnerHTML={{__html: DraftHelper.contentStateToHtml(contentState)}}
    />;
}
